import { render, staticRenderFns } from "./TechnicalSupport.vue?vue&type=template&id=e8a12e2a&scoped=true&"
import script from "./TechnicalSupport.vue?vue&type=script&lang=js&"
export * from "./TechnicalSupport.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalSupport.vue?vue&type=style&index=0&id=e8a12e2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a12e2a",
  null
  
)

export default component.exports